var player = {
	_width:0,
	_height:0,
	_mouseX:0,
	_mouseY:0,
	_mouseHoverX:0,
	_mouseHoverY:0,
	ident:0,
	params:{},
	lastIdent:null,
	lastDir:null,
	lastHeading:0,
	lastTabTime:0,
	from:null,
	dir:0,
	storage:"",
	current:{},
	currentView:{},
	all:[],
	folders:[],
	processClass:[],
	imagesLoaded:false,
	debug:false,
	list:null,
	orientation:null,
	lastHistory:[],
	lang:"",
	keys: {},
	keyCtrl: false,
	offline: false,
	variant: null,
	track: [],
	cms: 0,
	idle: true,
	idle_timer: null,
	turn_to: null,
	blockBackspace: false,
	pointerInfo: {},
	lastFrameTime: 0,
	currentFrameTime: 0,
	firstClick: false,

	getCookie: function(cname) {
	  var name = cname + "=";
	  var ca = document.cookie.split(';');
	  for(var i = 0; i < ca.length; i++) {
	    var c = ca[i];
	    while (c.charAt(0) == ' ') {
	      c = c.substring(1);
	    }
	    if (c.indexOf(name) == 0) {
	      return c.substring(name.length, c.length);
	    }
	  }
	  return undefined;
	},

	cancelIdle: function() {
		if (player.idle_timer != null) clearTimeout(player.idle_timer);
		player.idle = false;

		player.idle_timer = setTimeout(function() {
			player.idle = true;
			player.idle_timer = null;
		}, 20 * 1000);
	},

	introAddTab: function(node, focus) {
		Tab.add("intro", {
			"focus": function(m) {
				m.node.addClass("focused");
				if (m.focus == undefined) m.node.focus();
				else m.focus.focus();
			},

			"blur": function(m) {
				m.node.removeClass("focused");
			}

		}, {"node": node, "focus": focus});		
	},

	intro: function() {
		var intro = $("<div></div>");
		var bd = $("<div class='intro-bd'></div>");
		var b = $("<div class='intro-buttons'></div>");
		var s_on = $("<a href='javascript:void(null);' title='" + TPL.lng('intro.with_sound', 'Kliknij aby kontynuować oglądanie projektu z dźwiękiem.') + "' class='intro-button intro-faded'><img src='assets/sound_on.png'></a>");
		var s_off = $("<a href='javascript:void(null);' title='" + TPL.lng('intro.without_sound', 'Kliknij aby kontynuować oglądanie projektu bez dźwięku.') + "' class='intro-button intro-faded'><img src='assets/sound_off.png'></a>");

		if (PROJECT.settings['core/soundscreen'] != undefined && PROJECT.settings['core/soundscreen'] == "0") return;
		
		HotSpotManager2D.setVisibility(false);

		var s_on_img = new Image();
		s_on_img.onload = function() {
			s_on.removeClass("intro-faded");
		};
		s_on_img.src = "assets/sound_on.png";
		if (s_on_img.complete)  s_on.removeClass("intro-faded");

		var s_off_img = new Image();
		s_off_img.onload = function() {
			s_off.removeClass("intro-faded");
		};
		s_off_img.src = "assets/sound_off.png";
		if (s_off_img.complete)  s_off.removeClass("intro-faded");

		Tab.setGroup("intro", "+");
 
		player.introAddTab(s_on);
		player.introAddTab(s_off);

		intro.append(bd);
		intro.append(b);
		b.append(s_on);
		b.append(s_off);

		Tab.disableGroupsExcept("intro");

		s_on.click(function() {
			Tab.clearGroup("intro");
			Tab.enableAllGroups();
			intro.remove();
			Music.resumePlaying();
			HotSpotManager2D.setVisibility(true);

			if (PROJECT.settings['core/readtitle'] != undefined && PROJECT.settings['core/readtitle'] != "") {
				var rt = JSON.parse(PROJECT.settings['core/readtitle']);
				if (rt[player.lang] != undefined && rt[player.lang] != "")
					SpeechManager.speakTip(rt[player.lang],"TOPMENU");
			}
		});

		s_off.click(function() {
			Tab.clearGroup("intro");
			Tab.enableAllGroups();
			intro.remove();
			Music.toggle();
			HotSpotManager2D.setVisibility(true);
		});

		$("body").append(intro);
	},

	setupHistory: function(window) {
		
		//console.log("binding");
		
		//History.Adapter.bind(window,'statechange',function() {
		//$(window).bind('statechange',function() {
				
				/*
				var chs = player.currentHistoryState;
				
				if (chs.current == "inMenu") {
					player.toggleMenu();
				} else {
					//if (player.list.back) player.list.back();
					if (player.historyManager) player.historyManager.back();
					if (player.historyManager) player.historyManager.back();
				}
				
				player.saveLastHistory();
				
				event.preventDefault();
				*/
			//});
	},

	parseId: function(id) {
		id = id.toString();
		
		var tokens = id.split("!");
		var parts = [];	
		id = tokens[0];
		player.params = {};

		if (tokens.length > 1) for(var n in tokens) {
			if (n > 0) {
				parts = tokens[n].split("=");
				player.params[parts[0]] = parts[1];
			}
		}
		return id;
	},

	copyCoords: function() {
		var copyText = document.getElementById("cmscoords");
  		copyText.select();
  		document.execCommand("copy");
	},
	
	cmsMode: function(e) {
		player.cms = 1;

		//player.cmsnode = $("<div class='cms'>Koordynaty: <input type='text' id='cmscoords'><a href='javascript:void(null);' onclick='player.copyCoords();';><i class='fa fa-copy'></i></a></div>")
		
		//player.cmsnode = $("<div class='cms'><a href='javascript:void(null);' onclick='SpotEdit.add();'>Dodaj tabliczkę</a></div>")
		//$("#ui").append(this.cmsnode);
	},

	init: function(id, dir, _from, _storage, _debug) {
		Events.init();
		player.devauthtoken = player.getCookie("devauthtoken");

		TPL.init(PROJECT.settings['skin/folder'], function() {
			this.postload(id, dir, _from, _storage, _debug);
		}.bind(this));
	},

	postload: function(id, dir, _from, _storage, _debug) {

		// project settings
		if (PROJECT.settings['nearest'] == "0") $("#menubar_nearest").hide();
		// -----

		document.addEventListener('contextmenu', function(event) {
			//alert("Copyright: wirtualnykraj.pl");
			//event.preventDefault();
		});

		document.addEventListener('visibilitychange', function(event) {
			if (document.hidden) {
				Music.suppress(true);
			} else {
				Music.suppress(false);
			}
		});

		if (window.location.hash != undefined && window.location.hash != "" && window.location.hash.substr(1, 3) != "sub") {
			var hstr = window.location.hash.substr(1);
			if (hstr.substr(0, 1) == "/") hstr = hstr.substr(1);
			var tokens = hstr.split("/");
			id = player.parseId(tokens[0]);
			if (tokens.length > 1) dir = tokens[1];
		}

		player.internet = true;

		if (player.offline) {
			/*
			$.ajax({
				url : "https://www.wkraj.pl/online.txt",
				success: function(e) {player.internet = true},
				error: function(e) {player.internet = false}
			});
			*/
		}

		$("#bbar_menu").html(TPL.lng("bottombar.menu", "MENU"));
		$("#bbar_map").html(TPL.lng("bottombar.map", "MAPA"));

		PluginManager.onInit();
		
		//console.log(SETTINGS);
	
		window.requestAnimFrame = (function() {
			return  window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			function( callback ) {
				window.setTimeout(callback, 1000 / 60);
			};
		})();

	
		window.addEventListener("load",
			function() {
				setTimeout(function(){
					window.scrollTo(0, 1);
				}, 0);
			});

		/*
		History.Adapter.bind(window,'statechange',function(){
			var State = History.getState();			
		})			
		*/
		
		//History.Adapter.on(window, 'statechange',function() {
		/*
		window.addEventListener('statechange',function(){
				console.log("statechange");
			});
		*/
		
		/*
		if (window.DeviceOrientationEvent) {
			player.orientation = {};
			//$("#console").html("<span style='color:white;'>Device orientation supported</span>");							
			
			window.addEventListener('deviceorientation', function(eventData) {
				var compassdir;
				//$("#console").html("<span style='color:white;'>Device orientation event: " + eventData.alpha + " </span>");							
				
				if(eventData.webkitCompassHeading) {
					player.orientation.alpha = eventData.webkitCompassHeading;  
					player.orientation.compass = eventData.webkitCompassHeading;
				} else {
					player.orientation.alpha = eventData.alpha;
					player.orientation.compass = eventData.compassHeading;
				}
												
				player.orientation.beta = eventData.beta;
				player.orientation.gamma = eventData.gamma;
				
				$("#console").html("<span style='color:white;'>A: " + Math.round(player.orientation.alpha) + "<Br>B: " + Math.round(player.orientation.beta) + "<br>G: " + Math.round(player.orientation.gamma) + "<BR><BR>Heading:" + (360 - Compass.heading()) + "</span>");
			});
		} else {
			$("#console").html("<span style='color:white;'>Device orientation not supported</span>");			
		}
		*/	
		
		/*
		var promise = FULLTILT.getDeviceOrientation({ 'type': 'world' });		
		
		promise.then(function(deviceOrientation) {
			player.orientation = {};
			deviceOrientation.listen(function() {
				player.orientation = deviceOrientation.getScreenAdjustedEuler();
			});
		}).catch(function(errorMessage) {
			console.log(errorMessage);
		});		
		*/
		
		window.addEventListener("popstate", function(event) {
				var chs = player.currentHistoryState;
				
				//console.log(chs);
				
				if (chs != undefined && chs.current != undefined && chs.current == "inMenu") {				
//					player.toggleMenu();
				} else {					
					//if (player.list.back) player.list.back();
					if (player.historyManager) player.historyManager.back();
				}
								
				player.lastHistory.pop();
				
				player.saveLastHistory(player.lastHistory[player.lastHistory.length - 1]);
				
				//window.location.hash = player.ident + "/" + player.dir;
				//console.log("popstate");

				event.preventDefault();
			}
		);
		
		
		player.debug = _debug;
	
		player.storage = _storage;
	
		player._width = $(window).width();
		player._height = $(window).height();
						
		$("#player").css("width",(player._width) + "px");
		$("#player").css("height",(player._height) + "px");
		
		$(window).resize(player.onresize);
		
		window.addEventListener('onorientationchange', player.onOrientationChange);
		
		player.ident = _from;

		player.load(id, dir);
		player.lastIdent = player.ident;
		player.lastDir = dir;

		player.addTrack(0, 0);

		SpeechManager.prepareTip("PLAYER.CLOSE", "TIPS");
		SpeechManager.prepareTip("PLAYER.PREVIOS_PANO", "TIPS");		
		SpeechManager.prepareTip("PLAYER.MAP", "TIPS");
		SpeechManager.prepareTip("PLAYER.MENU", "TIPS");
		SpeechManager.prepareTip("PLAYER.SEARCH", "TIPS");
		
		$("#menu a").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.MENU", "TIPS");player.showMenu();});
		$("#infomenu a").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.CLOSE", "TIPS");placeInfo.toggleMenu();});
		//$("#mapinfo a").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.CLOSE", "TIPS");placeInfo.toggleMenu();});
		
		//$("#info").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.HELP.4.TITLE", "TIPS");placeInfo.toggleMenu();});
		$("#menubutton a").on(Events.pointer.down, function() {placeInfo.toggleMenu();});
		$("#mapbutton a").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.MAP", "TIPS");mapInfo.toggleMenu();});
		
		$("#menuHomeButton").on(Events.pointer.down, function() {player.list.multiBack();});
		$("#menubar_menu").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.MENU", "TIPS");menubar.closeCurrent();});
		$("#menubar_langicon").on(Events.pointer.down, function() {LanguageMenu.show(true);});		
		$("#menubar_nearest").on(Events.pointer.down, function() {NearestManager.show();});
		$("#navbar_close").on(Events.pointer.down, function() {SpeechManager.speakTip("PLAYER.CLOSE", "TIPS");player.hideMenu();});

		$("#menubar_menu .tip").html(TPL.lng("menubar.menu", "Menu"));
		$("#menubar_langicon .tip").html(TPL.lng("menubar.lang", "Język"));
		$("#menubar_nearest .tip").html(TPL.lng("menubar.nearest", "W pobliżu"));
		
		$("#player").on(Events.pointer.down, player.mouseDowned);
		$("#player").on(Events.pointer.move, player.mouseMoved);

		$(window).on('keydown', player.keyDown);
		$(window).on('keyup', player.keyUp);
		
		$('#player').on('DOMMouseScroll', player.onWheel);
		$('#player').on('mousewheel', player.onWheel);

		player.process();

//		Volume.setMuted(); // start muted
//		player.intro();
//		Music.toggle();
	},

	cycleInfo: function() {

		if (player.iv1 != undefined) clearTimeout(player.iv1);
		if (player.iv2 != undefined) clearTimeout(player.iv2);

		if (player._width > 760) {
			player.iv1 = setInterval(function() {
				$("#info").find(".labelshow").addClass("labelhiding");
				$("#info").find(".labelshow").removeClass("labelshow");

				player.iv2 = setTimeout(function() {
					if (!$("#info").find(".labelnext").length) {
						$("#info").find(".labelhide").addClass("labelnext");
						$("#info").find(".labelhide").removeClass("labelhide");

						$("#info").find(".labelhiding").addClass("labelhide");
						$("#info").find(".labelhiding").removeClass("labelhiding");
					}
					
					$("#info").find(".labelnext").addClass("labelshow");
					$("#info").find(".labelnext").removeClass("labelnext");

					$("#info").find(".labelhide").addClass("labelnext");
					$("#info").find(".labelhide").removeClass("labelhide");

					$("#info").find(".labelhiding").addClass("labelhide");
					$("#info").find(".labelhiding").removeClass("labelhiding");
				}, 900);
			}, 6000);
		}
	},
	
	load: function(id,dir,withTrans) {
		player.preload(true);
		player.freezedisort = true;

		if (withTrans !== true) {
			HotSpotManager.setTransition(undefined);
		}
		
		//console.log("Load " + id);

		id = Hs.trim(id)

		player.dirfrom = player.dir;
		player.dir = dir;
		player.from = player.ident; //_from;
		player.ident = id;
		
		if (player.currentView != undefined && player.currentView.clear  != undefined) player.currentView.clear();
		if (player.currentView != undefined && player.currentView != null && player.currentView.beforeLeave != null) player.currentView.beforeLeave();
		
		AppEvent.trigger(player, "beforeLoad",{});
		
		Remote.ajax({
				url: "placeloader.php?ident=" + id,
				offline: player.lang + "_" + id + ".json",
				dataType:"json",
				success: player.placeloaded
			});
	},
	
	placeloaded: function(data) {
		//console.log("player.domain: " + player.domain);
		//console.log("place.domain: " + player.current.domain);
		var samedomain = false;

		if (data.ERROR == "1000") {
			document.location = "https://www.wkraj.pl";
			return;
		}

		if (!player.offline) {		
			if (player.cms == 0) {
				for(var d in data.domains) {
					if (data.domains[d].host.toLowerCase() == window.location.hostname) samedomain = true;
				}

				if (data.domain.toLowerCase() + ".wkraj.pl" != window.location.hostname && !samedomain) {

					if (data.domains.length > 0) {
						var proto = data.domains[0].proto;
						if (proto == "") proto = document.location.protocol;
						document.location = proto + "//" + data.domains[0].host + "/html5/index.php?id=" + data.place_id + "#" + data.place_id + (player.dir != undefined ? "/" + player.dir : "");
					} else {
						document.location = document.location.protocol + "//" + data.domain + ".wkraj.pl/html5/index.php?id=" + data.place_id + "#" + data.place_id + (player.dir != undefined ? "/" + player.dir : "");
					}

					player.ident = player.from;
					player.dir = player.fromdir;
					window.location.hash = player.ident + (player.dir != undefined ? "/" + player.dir : "");				
					return;
				}
			}

			if (player.cms == 0 && player.domain != undefined && player.domain != "" && data.domain != "" && player.domain.toLowerCase() != data.domain.toLowerCase()) {
				player.ident = player.from;
				player.dir = player.fromdir;
				window.location.hash = player.ident + (player.dir != undefined ? "/" + player.dir : "");

				document.location = document.location.protocol + "//" + data.domain + ".wkraj.pl/html5/index.php?id=" + data.place_id + "#" + data.place_id + (player.dir != undefined ? "/" + player.dir : "");
				return;
			}

		}

		player.current = data;
		player.folder = player.current.folder.city_id;

		player.domain = player.current.domain;		


		if (player.offline) player.list = new multiMenuListNS();
		else player.list = new categoryList();
		
		AppEvent.trigger(player, "afterLoad",data);
		
		Remote.ajax({
//				url:"menuloader.php?folders=1&ident=" + id,
				url:"jsonloader.php?folders=1&ident=" + player.ident,
				offline:"menu.json",
				dataType:"json",
				success: player.loaded,
				error: player.error
		});

		player.preload(false);
	},
	
	error: function() {
		//player.list = new multiMenuList();

		player.list = new multiMenuListNS();
		$.ajax({
			url:"jsonsinglefolderloader.php?ident=" + player.ident, 
			dataType:"json",
			success: player.loadederr
			});
	},
	
	loadederr: function(data) {
		player.loaded(data);
	},

	loaded: function(data) {
		var elem;
		
		//Log.debug("loaded " + player.ident);

		Tab.clearGroup("hotspots");

		player.all = data;
		
		if (player.current.description == "" && player.current.properties.description != "")
			player.current.description = player.current.properties.description;

		placeInfo.load(player.current);
		mapInfo.load(player.current);
		
		player.list.loadPanoList(data);

		var ico = "<div class='title_icon'><img src='assets/start_black.png'></div> &nbsp;";

		var cat = "";
		if (player.current.psc_name != "" && player.current.psc_id > 0) {
		//	cat = player.current.psc_name + " - ";
		}

		if (player.current.place_name != "") {
			//$("#info").html("<div class='icon'>" + ico + "</div><div class='label labelshow'>" + cat + player.current.place_name + "</div>");
			$("#info").html("<div class='label labelshow' style='padding-left: 0px'>" + cat + player.current.place_name + "</div>");
		} else {
			//$("#info").html("<div class='icon'>" + ico + "</div><div class='label labelshow'>" + cat + "Panorama nr. " + player.current.place_id + "</div>");
			$("#info").html("<div class='label labelshow' style='padding-left: 0px'>" + cat + "Panorama nr. " + player.current.place_id + "</div>");
		}

		var locpath = player.current.folder.parent_folder.city_name + " - " + player.current.folder.city_name;
		if (player.current.folder.parent_folder.parent_folder != undefined && player.current.folder.parent_folder.parent_folder.city_name != undefined) {
			locpath = player.current.folder.parent_folder.parent_folder.city_name + " - " + locpath;
		}

		//$("#info").append($("<div class='label labelnext'>" + locpath + "</div>"));
		if (player._width > 760)
			$("#overlay").append($("<div class='label' style='position: absolute;left: 10px;bottom: 45px; text-shadow: 4px 4px 6px rgba(66, 68, 90, 1);color:#ffffff'>" + locpath + "</div>"));

		var viewcount = TPL.lng("PLAYER.VISITS", "Liczba wyświetleń:");
		var place_id = TPL.lng("PLAYER.PLACE_ID", "ID Miejsca:");
		var udate = TPL.lng("PLAYER.LAST_UPDATED", "Data wykonania:");

		if (PROJECT.settings['ui/bottom/stats'] == undefined || PROJECT.settings['ui/bottom/stats'] == "1")
			$("#info").append($("<div class='label labelhide' style='padding-left: 0px' aria-hidden='true'>" + viewcount + " " + player.current.visits + " &nbsp;|&nbsp; " + place_id + " " + player.current.place_id + " &nbsp;|&nbsp; " + udate + " " + player.current.photo_date + "</div>"));
		else if (PROJECT.settings['ui/bottom/date'] == undefined || PROJECT.settings['ui/bottom/date'] == "1")
			$("#info").append($("<div class='label labelhide' style='padding-left: 0px' aria-hidden='true'>" + place_id + " " + player.current.place_id + " &nbsp;|&nbsp; " + udate + " " + player.current.photo_date + "</div>"));

		player.cycleInfo();
		//player.current = player.list.getCurrent();
		
		/*
		$("#player").on("mousedown", player.mouseDown);
		$("#player").on("mouseup", player.mouseUp);
		$("#player").on("mousemove", player.mouseMove);
		*/
		
		if (player.currentView != null && player.currentView.leaving != undefined) {
			player.currentView.leaving();
			player.lastView = player.currentView;
		}

		if (player.current != null) {
			if (player.debug) {
				player.currentView = new panoramaGridView(player.ident, player.current);
			} else {
				//console.log(player.current.place_type);
				if (player.current.place_type == "panorama") {
					player.currentView = new panoramaView(player.ident, player.current, player.half, player.turn_to);
				} else if (player.current.place_type == "start") {
					player.currentView = new startView(player.ident, player.current);
					player.lastView = undefined;
				} else if (player.current.place_type == "photo") {
					player.currentView = new photoView(player.ident, player.current);
					player.lastView = undefined;
				} else if (player.current.place_type == "video") {
					player.currentView = new videoView(player.ident, player.current);
					player.lastView = undefined;
				} else if(player.current.place_type == "catalogue3D") {
					player.currentView = new gallery3DView(player.ident, player.current);
					player.lastView = undefined;
				} else if(player.current.place_type == "gallery") {
					player.currentView = new galleryView(player.ident, player.current);
					player.lastView = undefined;
				} else if(player.current.place_type == "autopilot") {
					player.lastView = undefined;
					player.currentView = null;
					Autoplay.start(player.ident, player.current);
				}
			}

			ElementManager.load(player.current.elements);

			if (player.currentView != null) player.currentView.load();
		} else {
			player.toggleMenu(null);
		}

		player.cancelIdle();

		if (!player.offline) {
			setTimeout(function() {
				$.ajax({"url": "../../panostat.php?ident=" + player.ident});
			}, 100);
		}

		AppEvent.trigger(player, "placeReady",{view: player.currentView});
		//setInterval("player.process()", 1000/60);

		if (PROJECT.settings['cookies/show'] == "1") {
			//alert(PROJECT.settings['cookies/text']);
    		var agree = localStorage.getItem('cookie-policy-agreed');

    		if (agree != 1) {
    			Dialog.cookie(function() {
    				localStorage.setItem('cookie-policy-agreed', 1);
    			});
			}
		}

		if (PROJECT.settings['accessibility/loadingsound'] == "1") {
			setTimeout(function() {
				//AudioManager.player("assets/audio/loadComplete.mp3").setLoop(false);
				AudioManager.play("assets/audio/loadComplete.mp3", Volume.currentTipVolume());
			}, 1000);
		}
	},

	saveLastHistory: function(so) {
//		var lastHistory = {};
		
		//jQuery.extend(player.lastHistory , so);
//		jQuery.extend(lastHistory , so);
//		jQuery.extend(lastHistory, history.state);
		//jQuery.extend(lastHistory, History.getState());
		//player.currentHistoryState = lastHistory;
//		console.log(so);

		player.lastHistory.push(so);

		player.currentHistoryState = so;
	},
	
	addToHistory: function(stateObj, title, url) {
		//url = url.replace("\#","?state=");
		title = "Wirtualny Kraj";

		history.pushState(stateObj, title, url);			
		player.saveLastHistory(stateObj);

		document.title = title;
		//alert("push " + url);

//		History.pushState(stateObj, title, "?adsa" + url);
	},
	
	setHistoryManager: function(hmg) {
		player.historyManager = hmg;
	},
	
	toggleMenu: function(event) {		
		try {
			setTimeout(function() {
				$("#panosback").toggle();
				$("#panosback a").toggle();
				$("#panos").toggleClass("visible");
				$("#menubar").toggle();
				player.list.openMenu(null);
			
				if ($("#panos").hasClass("visible")) {
					var stateObj = { "current": "inMenu"};
//					player.addToHistory(stateObj, "W menu", "#inMenu");
//					player.setHistoryManager(player.list);
				}
			}, 100);
		} catch(e) {
			Log.error(e.toString(),"player.toggleMenu");
		}
		
		if (event != null) event.preventDefault();
	},

	hideMenu: function() {
		menubar.closeCurrent();
		$("#panosback").hide();
		$("#panosback a").hide();
		$("#menubar").hide();
		$("#panels").show();
		$("#panos").removeClass("visible");
	},

	showMenu: function(event) {
		setTimeout(function() {
			//$("#panosback").show();
			$("#panosback a").show();
			$("#panos").addClass("visible");
			$("#menubar").show();
			$("#panels").hide();
			player.list.openMenu(null);
			
			var stateObj = { "current": "inMenu"};
//			player.addToHistory(stateObj, "W menu", "#inMenu");
//			player.setHistoryManager(player.list);
		}, 100);
		
		if (event != null) {
			//event.preventDefault();
			event.stopPropagation();
		}
	},
	
	onresize: function(event) {
		player._width = $(window).width();
		player._height = $(window).height();
		
		$("#player").css("width",player._width+"px");
		$("#player").css("height",player._height+"px");

		player.currentView.reorient(event);
		Menu.reorient(event);		
	},

	onOrientationChange: function() {		
		//player.currentView.reorient(event);
	},
	
	addProcess: function(cls) {
		player.processClass.push(cls);
	},
	
	removeProcess: function(cls) {
		var ind = player.processClass.indexOf(cls);
		player.processClass.splice(ind,1);
	},
	
	process: function() {
		window.requestAnimFrame(player.process);
		player.lastFrameTime = player.currentFrameTime;
		player.currentFrameTime = Date.now();

//		Jezeli to odblokuje to pojawia sie problem z przechodzeniem na poczatek
		if (player.lastView != undefined && player.lastView.process != undefined && (player.lastView.paused == undefined || !player.lastView.paused)) player.lastView.process();
		if (player.currentView != undefined && player.currentView.process != undefined && (player.currentView.paused == undefined || !player.currentView.paused)) player.currentView.process();
		
		if (sphereWebGLStatic.postRender) sphereWebGLStatic.postRender();

		for(proc in player.processClass) {
			player.processClass[proc].process();
		}

		AppEvent.trigger(player, "onProcess", {});		
	},

	keyDown: function(event) {
		player.keys[event.key] = 1;
		if (!event.ctrlKey) player.keyCtrl = false;
		if (event.ctrlKey) player.keyCtrl = true;
		player.cancelIdle();

		if (event.key == "Tab") {
			player.lastTabTime = Date.now();
			Tab.cycle(event.shiftKey);

			event.stopPropagation();
			return false;
		}

		Tab.keyDown(event);

		AppEvent.trigger(player, "PLAYER.KEYDOWN", event);
	},

	keyUp: function(event) {
		player.keys[event.key] = 0;
		if (!event.ctrlKey) player.keyCtrl = false;
		if (event.ctrlKey) player.keyCtrl = true;
		player.cancelIdle();

		if (Tab.keyUp(event))
			AppEvent.trigger(player, "PLAYER.KEYUP", event);

		if (event.key == 'Backspace' && player.blockBackspace == false && player.cms != 1) player.back();
		player.blockBackspace = false;
	},

	mouseDowned: function(event) {
		var pe = Events.getPointerEvent(event);

		player._mouseX = pe.pageX;
		player._mouseY = pe.pageY;
		
		player.currentView.mouseDown(pe);		
		
		AppEvent.trigger(player, "mouseDown",pe);

		$("body").one(Events.pointer.up, player.mouseUped);
		$("#c3d").css("cursor", "grabbing");
		player.cancelIdle();
	},
	
	mouseUped: function(event) {
		var pe = Events.getPointerEvent(event);
		player.currentView.mouseUp(pe);	

		AppEvent.trigger(player, "mouseUp",pe);
		$("#c3d").css("cursor", "grab");
		player.cancelIdle();

		if (!player.firstClick) {			
			AppEvent.trigger(player, "FIRST.CLICK", null);
			player.firstClick = true;
		}
	},
	
	mouseMoved: function(event) {
		var pe = Events.getPointerEvent(event);

		player.pointerInfo = pe;

		if (player.freezedisort == undefined) {
			player._mouseHoverX = pe.pageX;
			player._mouseHoverY = pe.pageY;
		}

		player.currentView.mouseMove(pe);
		AppEvent.trigger(player, "mouseMove",pe);

		player.cancelIdle();
		event.preventDefault();
	},

	onWheel: function(e) {
		var weight = -26;
		var isWebkit = 'WebkitAppearance' in document.documentElement.style;

		if (isWebkit) weight = 1;

		var dt = e.originalEvent.wheelDelta;
		if (isNaN(dt)) dt = e.originalEvent.detail;

		player.currentView.mouseWheel(dt * weight);
		AppEvent.trigger(player, "mouseWheel",dt);

		player.cancelIdle();
		e.preventDefault();
	},

	addTrack: function(ident, dir) {
		player.track.push({"ident": ident, "dir": dir});
		if (player.track.length > 5) player.track.shift();
	},

	go: function(id, dp, withTrans) {
		var dir;
		var raw = id;
		/*
		if (!Array.isArray(dp) && dp.indexOf("|") !== false) {
			var tokens = dp.split("|");
			dp = [tokens[0], tokens[1]];
			withTrans = true;
		}
		*/
		
		if (Array.isArray(dp)) {
			dir = dp[0];
			if (dp[1] != undefined) player.turn_to = dp[1].toString();
		} else {
			dir = dp;
			player.turn_to = undefined;
		}

		if (id == "0" || id == 0) return;
		player.cancelIdle();

		player.hideMenu();

		var parts = [];
		id = player.parseId(id);

		player.lastIdent = player.ident;
		player.lastDir = player.dir;

		if (player.currentView != null)
			player.addTrack(player.ident, player.currentView.getHeadingText != null ? player.currentView.getHeadingText() : 0);

		if (PROJECT.settings['accessibility/loadingsound'] == "1") {
//			AudioManager.play("assets/audio/loadComplete.mp3", Volume.currentTipVolume()); 
//			AudioManager.player("assets/audio/loadComplete.mp3").setLoop(true);
		}

		AppEvent.trigger(player, "PLAYER.GO", {"id": id, "dir": dir, "params": player.params});
		//try {
			if (String(id).toLowerCase() == "folder") {
				Library.open(raw.substr(7));
			} else if (String(id).substr(0,4).toLowerCase() == "http") {
				window.open(id,"_blank");
			} else {
				setTimeout(function() {
					window.location.hash = id + "/" + dir;
				}, 200);		

				player.load(id, dir, withTrans);
				//document.location = "index.php?id=" + id + "&dir=" + dir + "&from=" + player.ident;
			}
		//} catch(e) {
		//	Log.error(e.toString(), "player.go");
		//}
		
	},
	
	back: function() {
		var tl = player.track.length;
		ct = player.track.pop();
		player.go(ct.ident, ct.dir);
		player.track.pop();
//		player.go(player.track[tl - 1].ident, player.track[tl - 1].dir);
//		player.go(player.lastIdent, player.lastDir);
	},

	redraw: function() {
		// hack na androida
		document.body.scrollTop = 10;
		setTimeout(function() {
			document.body.scrollTop = 0
			window.scrollTo(0, 1)
		}, 100);
	},
	
	preload: function(b) {
		if (b) {
			if (player.prl != undefined) clearTimeout(player.prl);
			$("#loaderIcon").show();
		} else {
			player.prl = setTimeout(function() {
				$("#loaderIcon").hide();
				player.prl = undefined;
			}, 1000);
		}
	},

	bottomBar: function(b) {
		if (b) $(".bottombar").show();
		else $(".bottombar").hide();

		AppEvent.trigger(player, "BOTTOMBAR.TOGGLE",{"display": b});
	},

	setLang: function(lng) {
		if (lng == "") lng = "PL";
		player.lang = lng;

		try {
			var urlParams = new URLSearchParams(window.location.search);
			var sl = urlParams.get('setlang');

			if (sl != undefined && sl != "") player.lang = sl;
		} catch(e) {

		} 
	}
}